import { deliverMemberNotification } from '@/lib/notificationDelivery';

export function getTeamLeaderRecipients(leaders = [], churchMembers = [], teamLinkKey) {
  if (!teamLinkKey) return [];

  const churchById = new Map(churchMembers.map((m) => [m.id, m]));
  const recipients = new Map();

  for (const leader of leaders || []) {
    for (const linkedMember of leader?.members || []) {
      if (!linkedMember?.[teamLinkKey] || !linkedMember?.member_id) continue;
      const churchMember = churchById.get(linkedMember.member_id);
      if (!churchMember?.email) continue;

      recipients.set(churchMember.id, {
        member_id: churchMember.id,
        member_email: String(churchMember.email).trim().toLowerCase(),
        member_name: churchMember.full_name || linkedMember.member_name || 'Lider',
      });
    }
  }

  return [...recipients.values()];
}

export async function notifyTeamLeaders({
  base44,
  leaders = [],
  churchMembers = [],
  teamLinkKey,
  title,
  message,
  type,
  reference_id,
}) {
  const recipients = getTeamLeaderRecipients(leaders, churchMembers, teamLinkKey);
  if (recipients.length === 0) return { notified: 0 };

  await Promise.allSettled(
    recipients.map(async (recipient) => {
      await deliverMemberNotification({
        recipients: [recipient],
        title,
        message,
        type,
        referenceId: reference_id,
      });

      await base44.integrations.Core.SendEmail({
        to: recipient.member_email,
        subject: title,
        body: `<p>${message.replace(/\n/g, '<br/>')}</p>`,
      });
    })
  );

  return { notified: recipients.length };
}
